module.exports = {
	STORAGE_KEYS: {
		AUTH: 'evolve.welcome.defaultAuthType',
		REMEMBER_USERNAME: 'evolve.welcome.rememberUsername',
		USERNAME: 'evolve.welcome.username'
	},
	QUERY_PARAMS: {
		USERNAME: 'username',
		PLATFORM: 'platform'
	}
};
